function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76 108.475C22.2933 108.475 0 160 0 160V0C0 0 22.2933 51.5254 76 51.5254C129.707 51.5254 152 0 152 0V160C152 160 129.707 108.475 76 108.475Z",
  fill: "url(#paint0_linear_20033822_97810)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20033822_97810",
  x1: 0,
  y1: 80,
  x2: 152,
  y2: 80,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA580C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0B54FF"
})));

function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 160,
    viewBox: "0 0 152 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.168782baed7e995120cc903fcd2235b9.svg";
export { ForwardRef as ReactComponent };